import { gql } from '@apollo/client';

/**
 * Policy GraphQL Fragment - All fields matching GqlPolicy output type
 */
export const POLICY_FIELDS_FRAGMENT = gql`
  fragment PolicyFields on Policy {
    id
    name
    description
    policyType
    scope
    implementation
    rules {
      ruleId
      name
      priority
      conditions {
        field
        operator
        value
      }
      actions {
        actionType
        params
      }
    }
    auditLevel
    enabled
    active
    version
    associatedApprovalIds
    associatedDocumentIds
    associatedRoleIds
    workflowInstanceId
    formulaContext
    evaluationCount
    cacheHitRate
    avgEvaluationTimeMs
    parentId
    originalId
    recordVersion
    isActive
    metadata
  }
`;
